export default __webpack_public_path__ + "static/media/step1.a7af430a.svg";